import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, ref, watchEffect } from 'vue';
import { useAppStore } from '@/store/modules/app';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Pagination'
  },
  __name: 'index',
  props: {
    // 总条目数
    total: {
      required: true,
      type: Number
    },
    // 当前页数：pageNo
    page: {
      type: Number,
      default: 1
    },
    // 每页显示条目个数：pageSize
    limit: {
      type: Number,
      default: 20
    },
    // 设置最大页码按钮数。 页码按钮的数量，当总页数超过该值时会折叠
    // 移动端页码按钮的数量端默认值 5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7
    }
  },
  emits: ['update:page', 'update:limit', 'pagination'],
  setup(__props, {
    emit: __emit
  }) {
    // 此处解决了当全局size为small的时候分页组件样式太大的问题
    const appStore = useAppStore();
    const layoutCurrentSize = computed(() => appStore.currentSize);
    const isSmall = ref(layoutCurrentSize.value === 'small');
    watchEffect(() => {
      isSmall.value = layoutCurrentSize.value === 'small';
    });
    const props = __props;
    const emit = __emit;
    const currentPage = computed({
      get() {
        return props.page;
      },
      set(val) {
        // 触发 update:page 事件，更新 limit 属性，从而更新 pageNo
        emit('update:page', val);
      }
    });
    const pageSize = computed({
      get() {
        return props.limit;
      },
      set(val) {
        // 触发 update:limit 事件，更新 limit 属性，从而更新 pageSize
        emit('update:limit', val);
      }
    });
    const handleSizeChange = val => {
      // 如果修改后超过最大页面，强制跳转到第 1 页
      if (currentPage.value * val > props.total) {
        currentPage.value = 1;
      }
      // 触发 pagination 事件，重新加载列表
      emit('pagination', {
        page: currentPage.value,
        limit: val
      });
    };
    const handleCurrentChange = val => {
      // 触发 pagination 事件，重新加载列表
      emit('pagination', {
        page: val,
        limit: pageSize.value
      });
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _withDirectives((_openBlock(), _createBlock(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        background: false,
        "page-sizes": [10, 20, 30, 50, 100],
        "pager-count": __props.pagerCount,
        total: __props.total,
        small: true,
        class: "float-right mb-15px mt-15px",
        layout: "prev, pager, next",
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "pager-count", "total"])), [[_vShow, __props.total > 0]]);
    };
  }
});